module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "blood-glucose-ranges"
  }, [(!_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "top-label"
  }, [_vm._v(_vm._s(_vm.ranges.total) + " " + _vm._s(_vm.$t('message.visualizationBloodGlucoseHeader')))]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "top-label"
  }, [_vm._v(_vm._s(_vm.$t('message.loadingText')))]) : _vm._e(), _vm._v(" "), _c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [(_vm.isLoading) ? _c('div', [_c('radial-progress', {
    attrs: {
      "data-id": "radial-loading-1",
      "value": 0,
      "suffix": "%",
      "color": "#0179d5"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('radial-progress', {
    attrs: {
      "data-id": "radial-1",
      "value": _vm.lower,
      "suffix": "%",
      "color": "#0179d5"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelBelowRange')) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.ranges.lower) + "\n        ")])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [(_vm.isLoading) ? _c('div', [_c('radial-progress', {
    attrs: {
      "data-id": "radial-loading-2",
      "value": 0,
      "suffix": "%",
      "color": "#89C93B"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('radial-progress', {
    attrs: {
      "data-id": "radial-2",
      "value": _vm.inRange,
      "suffix": "%",
      "color": "#89C93B"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelInRange')) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.ranges.in_range) + "\n        ")])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [(_vm.isLoading) ? _c('div', [_c('radial-progress', {
    attrs: {
      "data-id": "radial-loading-3",
      "value": 0,
      "suffix": "%",
      "color": "#89C93B"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('radial-progress', {
    attrs: {
      "data-id": "radial-3",
      "value": _vm.upper,
      "suffix": "%",
      "color": "#E74C3C"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('message.labelAboveRange')) + "\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.ranges.upper) + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-761d4e50","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Visualizations/BloodGlucose/BloodGlucoseRange.vue
// module id = 3234
// module chunks = 1